import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import { ActionButtonModule } from '../../../../shared/components/action-button';
import { ReactiveFormInputFieldModule } from '../../../../shared/components/reactive-forms-input/reactive-form-input-field/reactive-form-input-field.module';
import { LoginHeaderModule } from '../login-header/login-header.module';
import { ForgotUsernameComponent } from './container/forgot-username.component';

@NgModule({
  declarations: [ForgotUsernameComponent],
  imports: [
    CommonModule,
    NzIconModule,
    ReactiveFormsModule,
    I18nModule,
    UrlModule,
    RouterModule,
    ReactiveFormInputFieldModule,
    ActionButtonModule,
    LoginHeaderModule,
  ],
  exports: [ForgotUsernameComponent],
})
export class ForgotUsernameModule {}
